const GlobalPresence = () => {
    return (
        <div className="GlobalPresence">
            <h3>Global Presence</h3>
            <div className="presenceTiles">
                <div className="presenceTile">
                    <b>83</b>
                    <span>Countries</span>
                </div>
                <div className="presenceTile">
                    <b>200</b>
                    <span>Offices</span>
                </div>
                <div className="presenceTile">
                    <b>7</b>
                    <span>Regions</span>
                </div>
            </div>
        </div>
    );
};

export default GlobalPresence;
